import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { AdminService } from '../../services/Admin.service';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit, AfterViewInit {
  name = '';
  jetSupportUrl = '';
  userInfo: any;
  constructor(private _authService: AuthService,
    private _router: Router,
    private adminSVC: AdminService,
    private dataSvc: DataService,
    private titleSvc: Title) {
      this.userInfo = this.dataSvc.userDisplayInfo;
      if (dataSvc.userDisplayInfo) {
        this.name = dataSvc.userDisplayInfo.FirstName + ' ' + dataSvc.userDisplayInfo.LastName;
      }
      titleSvc.setTitle('MyJSSI Vendor');
    }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    this.jetSupportUrl = await this.adminSVC.getConfig('JetsupportUrl');
  }

  logOut() {
    this._authService.logOut();
    window.open(this.jetSupportUrl + 'log-in', '_self');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/vendor.component.ts